import styled from "styled-components";

export const Page = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
export const Wrapper = styled.div`
  overflow: hidden;
  margin: 10px auto;
  width: ${({ full }) => (full ? "96%" : "48%")};
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05), 0 0px 40px rgba(0, 0, 0, 0.08);
  border-radius: 5px;

  @media (max-width: 1024px) {
    width: 96%;
  }
`;

export const Title = styled.h1`
  background-color: darkgray;
  font-family: Arial, Helvetica, sans-serif;
  color: white;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 0.5px solid lightgray;
`;
